<template>
  <div>
    <select
      v-model="currentLocale"
      class="form-input pr-8"
    >
      <option
        v-for="(locale, i) in $i18n.availableLocales"
        :key="i"
        :value="locale"
      >
        {{ $t(`languages.${locale}`) }}
      </option>
    </select>
  </div>
</template>

<script setup lang="ts">
import { useI18nStore } from '@/store/i18n';
import { computed } from 'vue';

const i18nStore = useI18nStore();

const currentLocale = computed({
  get: () => i18nStore.currentLocale,
  set: (value) => i18nStore.setLocale(value),
});
</script>

<style scoped></style>
